import React, {ReactNode} from 'react'
import styles from './UIGameCount.module.scss'
import clsx from 'clsx'
import {PlayerColor} from '@colonist/game-states'
import {getPlayerColorHex} from '../../utils/gameColors'

export type UIGameCountSize = 'xxxs' | 'xxs' | 'xs' | 'sm' | 'base'

export interface UIGameCountProps {
    className?: string
    count: ReactNode
    color: PlayerColor
    size?: UIGameCountSize
}

export function UIGameCount({
    className,
    count,
    color,
    size = 'base',
}: UIGameCountProps) {
    const backgroundColor = getPlayerColorHex(color)

    return <div className={clsx(styles.container, className, styles[size])} style={{backgroundColor: backgroundColor}}>
        <div className={clsx(styles.count, styles[size])}>{count}</div>
    </div>
}
